import React from "react";
import {connect} from "react-redux";
import Button from "components/Button";
import Spinner from "components/Spinner";
import { closeCheckout, processSecureTradingPaymentResponse, saveAudit } from "state/school_money/actions";
import { getSecureTradingCardPayJWTString } from "state/school_money/selectors";

import "./CardDetails.css";

const ONLINE_PAY_BUTTON_CHECK_DELAY = 500;

class CardDetails extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      cardPayButtonCheckInterval: undefined,
      payButtonClicked: false
    }
  }

  componentDidMount(){
    this.props.saveAudit("ST_CARD_DETAILS_TOKEN_GENERATED");
    this.setState({ cardPayButtonCheckInterval: setInterval(this.checkCardPaymentFields, ONLINE_PAY_BUTTON_CHECK_DELAY) });
    var st = window.SecureTrading({
      jwt: this.props.jwtString,
      styles: {
          'border-radius-input': '9999px',
          'border-color-input': '#DADAD9',
          'border-size-input': '1px',
          'font-size-input': '14px',
          'border-radius-input-error': '9999px',
          'border-color-input-error': '#E44E3F',
          'font-size-label': '16px',
          'font-size-message': '16px',
          'color-error': '#E44E3F',
          'line-height-body': '0',
          'background-color-input-error': '#FFFFFF'
      },
      submitOnSuccess: false,
      submitCallback: this.processPaymentResponse,
      disableNotification: true,
      livestatus: parseInt(process.env.REACT_APP_SECURE_TRADING_3DS_LIVESTATUS, 10),
      translations: {"Value mismatch pattern": "Invalid value"}
    });
    st.Components();

    st.on("paymentStarted", (data) => {
      this.setState({ payButtonClicked: true });
    });

  }

  processPaymentResponse = (response) => {
    if( response.errorcode === "30000" ){return;}
    this.props.processPaymentResponse(response);
  }

  auditPaymentStart = () => {
    this.props.saveAudit("PAYMENT_PROCESS_STARTED");
  }

  checkCardPaymentFields = () => {
    if( document.getElementById("st-card-number").innerHTML !== "" ){
      this.setState({ isLoading: false });
      clearInterval(this.state.cardPayButtonCheckInterval);
    }
  }

  getPayButtonContent = () => {
    if(!this.state.payButtonClicked) {
      return "Pay";
    }

    return <Spinner size="small" color="white" />;
  }

  render() {
    const loadingFrameStyle = this.state.isLoading ? {display: "block"} : {display: "none"};
    return (
      <div className="card-details__container">
        <div style={loadingFrameStyle} className="card-details__spinner">
          <div>Please wait...</div>
          <Spinner size="standalone" color="school_money" />
        </div>
        <div id="st-notification-frame"></div>
        <form id="st-form" action="" method="POST">
          <div id="st-card-number" className="st-card-number"></div>
          <div id="st-expiration-date" className="st-expiration-date"></div>
          <div id="st-security-code" className="st-security-code"></div>
          <button id="st-form__submit" type="submit" className="card-details__pay-button" onClick={ this.auditPaymentStart }>{this.getPayButtonContent()}</button>
        </form>
        <div className="card-details__button-container">
          <Button className="card-details__cancel-button" onClick={ this.props.onClose }>Cancel</Button>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    jwtString: getSecureTradingCardPayJWTString(state)
  }),
  {
    onClose: closeCheckout,
    processPaymentResponse: processSecureTradingPaymentResponse,
    saveAudit: saveAudit
  }
)(CardDetails);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/secure_trading/CardDetails.js